import { createSlice } from "@reduxjs/toolkit"

export const customerCartSlice = createSlice({
	name: "customerCart",
	initialState: {
		customerCart: "",
		errors: [],
	},

	reducers: {
        getCustomerCart: (state, action) => {
            //console.log(action.payload);
			state.customerCart = action.payload
		},
		getCustomerCartList: (state, action) => {
			state.customerCart = action.payload
		},
		getErrors: (state, action) => {
            //console.log(action.payload);
			state.errors = action.payload
		},
	},
})
export const {getCustomerCart, getCustomerCartList, getErrors} = customerCartSlice.actions

export default customerCartSlice.reducer
